// import api from "../../../../api/mainApi";

export const curriculumReducer = (state, action) => {
  switch (action.type) {
    case "loadCurriculum":
      console.log("loading curriculum");
      return loadCurriculum(state, action.curriculums);
    case "addCurriculum":
      console.log("adding curriculum");
      return addCurriculum(state, action.curriculum);
    case "editCurriculum":
      console.log("editing curriculum");
      return editCurriculum(state, action.curriculum);
    case "disableCurriculum":
      console.log("disabling Curriculum");
      return disableCurriculum(state, action.id);
    default:
      return state;
  }
};

const loadCurriculum = (state, curriculums) => {
  let newState = [...curriculums];

  return newState;

  //console.log(curriculum.data.curriculums);
};

const addCurriculum = (state, curriculum) => {
  console.log(curriculum);
  const newState = [
    ...state,
    {
      id: Date.now().toString(),
      name: curriculum.name,
      //owner: curriculum.owner,
      program_type: curriculum.program_type,
      admission_type: curriculum.admission_type,
      stream: curriculum.stream,
      payment_rate: curriculum.payment_rate,
      starting_date: curriculum.starting_date,
      active: 1,
    },
  ];
  return newState;
};

const editCurriculum = (state, curriculum) => {
  const newState = [...state];
  const index = newState.findIndex((c) => c.id == curriculum.id);
  console.log(index, curriculum);
  newState[index] = {
    ...newState[index],
    name: curriculum.name,
    owner: curriculum.owner,
    program_type: curriculum.program_type,
    admission_type: curriculum.admission_type,
    stream: curriculum.stream,
    payment_rate: curriculum.payment_rate,
    starting_date: curriculum.starting_date,
  };
  return newState;
};

const disableCurriculum = (state, id) => {
  const newState = [...state];
  const index = newState.findIndex((c) => c.id == id);
  console.log(index);
  newState[index] = {
    ...newState[index],
    active: Number(!newState[index].active),
  };
  return newState;
};
